import styled from "@emotion/styled"

export const LoginLayout = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    min-height: 600rem;
    padding: 0 24rem;
    font-family: "Gilroy", monospace;
    background: linear-gradient(to bottom, #ffc5d3 0%, #ffffff 10%, #ffffff 100%);
    user-select: none;
`
